/* assets/customdt-card.js
   Add-to-cart for DT product cards — Be Yours 7.2.2 compatible.
   Replicates the theme's product-form.onSubmitHandler using the confirmed
   <mini-cart> API: getSectionsToRender(), renderContents(), open().
   Event delegation = survives infinite-scroll / filter re-renders. */
(function () {
  function getMiniCart() {
    return document.querySelector('mini-cart');
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.classList.contains('loading')) return;

    // If the theme is set to cart PAGE (not drawer), just let it behave normally
    var drawerEnabled = window.theme && window.theme.shopSettings && window.theme.shopSettings.cartDrawer;
    var miniCart = getMiniCart();

    var labelEl = btn.querySelector('.DT_pcard__atc-label');
    var original = btn.innerHTML;

    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');
    if (labelEl) labelEl.textContent = 'Adding…';

    // Build form data the same way the theme does
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
      try {
        var sections = miniCart.getSectionsToRender().map(function (s) { return s.id; });
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
      } catch (e) { /* ignore */ }
    }

    var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url)
      ? window.theme.routes.cart_add_url
      : '/cart/add';

    var config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    };

    fetch(addUrl, config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          // Error (e.g. sold out / not enough stock)
          if (labelEl) labelEl.textContent = 'Unavailable';
          setTimeout(function () {
            btn.innerHTML = original;
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
          }, 1800);
          return;
        }

        // Success — repopulate + open the drawer using the theme's own API
        if (miniCart && drawerEnabled !== false) {
          if (typeof miniCart.renderContents === 'function') {
            miniCart.renderContents(response);
          }
          if (typeof miniCart.open === 'function') {
            miniCart.open();
          }
        }

        // Fire theme events too (belt & suspenders)
        try {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'DT-product-card',
              productVariantId: variantId
            });
          }
        } catch (e) { /* ignore */ }
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: response } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: response } }));

        // Button success state
        btn.innerHTML =
          '<span class="DT_pcard__atc-inner">' +
            '<svg class="DT_pcard__atc-icon" viewBox="0 0 24 24" aria-hidden="true"><polyline points="5 12 10 17 19 7"></polyline></svg>' +
            '<span class="DT_pcard__atc-label">Added</span>' +
          '</span>';
        setTimeout(function () {
          btn.innerHTML = original;
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
        }, 1600);
      })
      .catch(function () {
        if (labelEl) labelEl.textContent = 'Try again';
        setTimeout(function () {
          btn.innerHTML = original;
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
        }, 1800);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dt-pcard-atc]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });
})();
